import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { BottomSheet, BottomSheetContentLayout, Drawer, Typography } from 'seagull';
import { getNotificationPresentationData } from "./InAppNotificationsDrawer.utils";
import { useEventReporter } from "../../event-reporter";
import { timeModel } from "../../models";
import { useMobileResponsiveness } from "../../providers/DeviceProvider";
import { selectors } from "../../store/state-selectors";
import { useStore, useStoreActions } from "../../store/store-context";
import styles from "./InAppNotificationsDrawer.module.scss";
import EmptyStateIllustration from "./InAppNotificationsEmptyStateIllustration.svg";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function InAppNotificationsDrawer() {
  const {
    isMobileDevice
  } = useMobileResponsiveness();
  const {
    data
  } = useStore(state => state.inAppNotifications);
  const worksAt = useStore(selectors.user.business);
  const email = useStore(selectors.user.email);
  const inAppNotificationsDrawerOpen = useStore(state => state.inAppNotificationsDrawerOpen);
  const {
    api,
    logBI,
    fetchInAppNotifications,
    setInAppNotificationsDrawerOpen
  } = useStoreActions();
  const {
    reportToHeap
  } = useEventReporter();
  const headerText = {
    title: 'Notifications center',
    subtitle: worksAt === null || worksAt === void 0 ? void 0 : worksAt.name
  };
  useEffect(() => {
    if (inAppNotificationsDrawerOpen && data) {
      const unseenNotificationIds = data.filter(pn => pn.id && !pn.seen).map(pn => pn.id);
      if ((unseenNotificationIds === null || unseenNotificationIds === void 0 ? void 0 : unseenNotificationIds.length) > 0) {
        api.inAppNotifications.markAsSeen(unseenNotificationIds);
      }
    }
  }, [inAppNotificationsDrawerOpen, data]);
  const content = data !== null && data !== void 0 && data.length ? data.map((notificationItem, index) => {
    var _notificationData$pat;
    const notificationData = getNotificationPresentationData(notificationItem);
    if (!notificationData) return null;
    const Element = notificationData.path ? NavLink : 'div';
    return /*#__PURE__*/_jsxs(Element, {
      to: (_notificationData$pat = notificationData.path) !== null && _notificationData$pat !== void 0 ? _notificationData$pat : '',
      id: notificationItem.id,
      "data-testid": "notification-item-".concat(index),
      "data-heapid": "notification-item",
      onClick: async () => {
        const notificationType = notificationItem[notificationItem.type].type;
        logBI(15001, {
          notificationType
        });
        reportToHeap('notification-center', 'click', 'vendor-clicked-notification-item', {
          email,
          notificationType
        });
        if (!notificationItem.read) {
          api.inAppNotifications.markAsRead(notificationItem.id);
          await fetchInAppNotifications();
        }
      },
      className: styles.item,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.icon,
        children: notificationData.icon
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.main,
        children: [/*#__PURE__*/_jsx("div", {
          "data-testid": "notification-item-description-".concat(notificationData.type, "-").concat(index),
          "data-heapid": "notification-item-description",
          children: /*#__PURE__*/_jsx(Typography, {
            children: notificationData.content
          })
        }), /*#__PURE__*/_jsx("div", {
          "data-testid": "notification-item-time-ago-".concat(index),
          "data-heapid": "notification-item-time-ago",
          children: /*#__PURE__*/_jsx(Typography, {
            skin: "secondary",
            variant: "paragraph3",
            children: timeModel.formatTimeAgo(notificationItem.timestamp)
          })
        })]
      }), !notificationItem.read && /*#__PURE__*/_jsx("div", {
        "data-testid": "read-item-dot",
        className: styles.readItemDotContainer,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.readItemDot
        })
      })]
    }, notificationItem.id);
  }) : /*#__PURE__*/_jsxs("div", {
    className: styles.emptyState,
    "data-testid": "notification-center-drawer-empty-state",
    children: [/*#__PURE__*/_jsx(EmptyStateIllustration, {}), /*#__PURE__*/_jsx(Typography, {
      variant: "h6",
      children: "You can sit down and relax"
    }), /*#__PURE__*/_jsx(Typography, {
      children: "You have no notifications"
    })]
  });
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "notification-center",
    children: isMobileDevice ? /*#__PURE__*/_jsx(BottomSheet, {
      open: inAppNotificationsDrawerOpen,
      onClose: () => setInAppNotificationsDrawerOpen(false),
      paddingBottom: 0,
      children: /*#__PURE__*/_jsx(BottomSheetContentLayout, {
        header: {
          title: headerText.title,
          subtitle: headerText.subtitle,
          paddingBottom: 8
        },
        children: content
      })
    }) : /*#__PURE__*/_jsx(Drawer, {
      hasTopbar: true,
      header: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h5",
          weight: "bold",
          children: headerText.title
        }), /*#__PURE__*/_jsx(Typography, {
          skin: "secondary",
          variant: "paragraph3",
          children: headerText.subtitle
        })]
      }),
      open: inAppNotificationsDrawerOpen,
      onClose: () => setInAppNotificationsDrawerOpen(false),
      onCloseButtonClick: () => setInAppNotificationsDrawerOpen(false),
      testId: "notification-center-drawer",
      BackdropProps: {
        invisible: true
      },
      children: content
    })
  });
}